const ChatItem = ({ current, fname, lname, message, type, fileURL }) => {
  const time = message.slice(0, 5);
  const text = message.slice(5);
  const lName = type === 0 ? ` ${lname}` : "";

  return (
    <div className="chat-wrapper">
      {current ? null : (
        <div className="chat-img">
          {type === 1 ? (
            <div className="manager">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="22"
                height="28"
                viewBox="0 0 22 28"
                fill="none"
              >
                <path
                  d="M11.7814 0.0844085L20.3775 5.72284C21.3913 6.38787 22 7.50377 22 8.69825L22 8.7012C22 9.89568 21.3918 11.0116 20.3775 11.6766L11.7814 17.315C11.4482 17.5336 11 17.2998 11 16.9069L11 14.9216C11 14.5287 10.5524 14.2949 10.2186 14.5135L3.22638 19.0974C3.07783 19.1947 3.07783 19.4083 3.22638 19.5056L10.2186 24.09C10.5519 24.3086 11 24.0748 11 23.6819L11 21.3003C11 20.9727 11.1666 20.6667 11.4451 20.4844L21.8048 13.6893C21.8881 13.6348 22 13.6933 22 13.7915L22 15.4762C22 16.6706 21.3918 17.7865 20.3775 18.4516L11.4451 24.3105C11.1671 24.4927 11 24.7987 11 25.1263L11 27.5079C11 27.9009 10.5524 28.1346 10.2186 27.9161L1.62247 22.2776C0.608239 21.6126 -3.27978e-07 20.4967 -3.80191e-07 19.3022C-4.32404e-07 18.1078 0.608239 16.9919 1.62247 16.3268L10.2186 10.6884C10.5518 10.4698 11 10.7036 11 11.0965L11 13.0818C11 13.4747 11.4476 13.7085 11.7814 13.4899L18.7726 8.90453C18.9212 8.80728 18.9212 8.59363 18.7726 8.49639L11.7814 3.91098C11.4481 3.69242 11 3.92621 11 4.31913L11 6.70368C11 7.03128 10.8334 7.33727 10.5549 7.51948L0.195218 14.3141C0.111911 14.3686 -5.98402e-07 14.3102 -6.02696e-07 14.2119L-6.76356e-07 12.5268C-7.28568e-07 11.3323 0.608239 10.2169 1.62197 9.55138L10.5554 3.68947C10.8334 3.50725 11 3.20127 11 2.87367L11 0.492065C11 0.0991425 11.4476 -0.134646 11.7814 0.0839169L11.7814 0.0844085Z"
                  fill="#00EB77"
                />
              </svg>
            </div>
          ) : (
            <div className="client">
              {fname.slice(0, 1).toUpperCase()}
              {lname.slice(0, 1).toUpperCase()}
            </div>
          )}
        </div>
      )}

      <div className={`chat-item ${current ? "right" : "left"}`}>
        <div className="chat-item__top">
          <p className="chat-item__top-name">
            {fname + lName}
            <span>
              {current ? " (You)" : type === 1 ? fname === "CryptoHub" ? " (Bot)" : " (Manager)" : " (Client)"}
            </span>
          </p>
          <p className="chat-item__top-time">{time}</p>
        </div>

        <p className="chat-item__bot">{text}</p>
        {/* <ul className="container-download">
          {fileURL.map((t) => (

            t.split('.').pop() === "png" ? null : <li className={current ? "" : "white"}>
              <a href={`https://chcontent.fra1.cdn.digitaloceanspaces.com/transactions/${t}`}><i className="ri-file-download-line hover"></i><i className="ri-file-2-line no-hover"></i></a>
            </li>
          ))}
        </ul>
        {fileURL.map((t) => (
          t.split('.').pop() === "png" ? <img className="img-download" src={`https://chcontent.fra1.cdn.digitaloceanspaces.com/transactions/${t}`} alt="" /> : null
        ))} */}

        <ul className="container-download">
          {fileURL ? fileURL.map((t) => (
          
            <li className={current ? "" : "white"}>
              <a href={`https://chcontent.fra1.cdn.digitaloceanspaces.com/transactions/${t}`} target="_blank" rel="noreferrer"><i className="ri-file-download-line hover"></i><p className="no-hover">{t.split('.').pop().toUpperCase()}</p></a>
            </li>
          )) : null}
        </ul>

      </div>
    </div>
  );
};

export default ChatItem;
